import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
	HomePageLayoutBlueprint,
	HomePageWidgetBlueprint,
} from '@backstage/plugin-home-react/alpha';

type HomePageModule = typeof import('../../components/home/HomePage');

const widget = (
	name: string,
	component: keyof HomePageModule,
	layout: { defaultColumns: number; defaultRows: number },
) =>
	HomePageWidgetBlueprint.make({
		name: name.toLowerCase(),
		params: {
			name,
			components: async () => {
				const homePage = await import('../../components/home/HomePage');
				return {
					Content: homePage[component] as HomePageModule['SearchWidget'],
					Renderer: homePage.BareRenderer,
				};
			},
			layout: {
				width: { defaultColumns: layout.defaultColumns, minColumns: 2 },
				height: { defaultRows: layout.defaultRows, minRows: 2 },
			},
		},
	});

const homePageLayout = HomePageLayoutBlueprint.make({
	params: {
		loader: async () =>
			(await import('../../components/home/HomePage')).HomePage,
	},
});

export const homeModule = createFrontendModule({
	pluginId: 'home',
	extensions: [
		homePageLayout,
		widget('Search', 'SearchWidget', { defaultColumns: 12, defaultRows: 2 }),
		widget('StarredEntities', 'StarredEntitiesWidget', { defaultColumns: 5, defaultRows: 5 }),
		widget('PullRequests', 'PullRequestsWidget', { defaultColumns: 7, defaultRows: 5 }),
		widget('HesselToolkit', 'HesselToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('GitHubToolkit', 'GitHubToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('DevOpsToolkit', 'DevOpsToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('AtlassianToolkit', 'AtlassianToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('ElasticToolkit', 'ElasticToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('OtherToolkit', 'OtherToolkitWidget', { defaultColumns: 4, defaultRows: 4 }),
		widget('ProgrammingJoke', 'ProgrammingJokeWidget', { defaultColumns: 6, defaultRows: 4 }),
		widget('DadJoke', 'DadJokeWidget', { defaultColumns: 6, defaultRows: 4 }),
	],
});
